"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchComplaintWards = exports.fetchCloseComplaints = exports.fetchComplaintsNew = exports.fetchCompalainDepartment = exports.fetchComplaintCategories = exports.sendMessageMedia = exports.sendMessageTo = exports.sendMessage = exports.fetchComplaints = exports.getComplaintDisplayOrder = exports.fetchComplaintAutoRouting = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _actionTypes = require("./actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _actions = require("../common/actions");

var commonActions = _interopRequireWildcard(_actions);

var _endPoints = require("egov-ui-kit/utils/endPoints");

var _api = require("egov-ui-kit/utils/api");

var _difference = require("lodash/difference");

var _difference2 = _interopRequireDefault(_difference);

var _uniq = require("lodash/uniq");

var _uniq2 = _interopRequireDefault(_uniq);

var _common = require("config/common.js");

var _common2 = _interopRequireDefault(_common);

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _localStorageUtils2 = require("../../utils/localStorageUtils");

var _actions2 = require("egov-ui-kit/redux/app/actions");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//checking users there in action history
var checkUsers = function checkUsers(dispatch, state, actionHistory, hasUsers, tenantId) {
  if (hasUsers) {
    var employeeIds = [],
        userIds = [];
    actionHistory.forEach(function (actions) {
      actions && actions.actions && actions.actions.forEach(function (action) {
        if (action.by) {
          var _getUserEmployeeId = getUserEmployeeId(action.by),
              userId = _getUserEmployeeId.userId,
              employeeId = _getUserEmployeeId.employeeId;

          if (userId) userIds.push(userId);
          if (employeeId) employeeIds.push(employeeId);
        }
        if (action.assignee) {
          var _getUserEmployeeId2 = getUserEmployeeId(action.assignee),
              _userId = _getUserEmployeeId2.userId,
              _employeeId = _getUserEmployeeId2.employeeId;

          if (_userId) userIds.push(_userId);
          if (_employeeId) employeeIds.push(_employeeId);
        }
      });
    });
    var common = state.common,
        auth = state.auth;

    if (employeeIds.length > 0) {
      var cachedEmployeeIds = [];
      if (common && common.employeeById) {
        cachedEmployeeIds = Object.keys(common.employeeById);
      }
      var value = (0, _uniq2.default)((0, _difference2.default)(employeeIds, cachedEmployeeIds)).indexOf(auth.userInfo.id) === -1 && auth.userInfo.type !== "CITIZEN" ? [].concat((0, _toConsumableArray3.default)((0, _uniq2.default)((0, _difference2.default)(employeeIds, cachedEmployeeIds))), [auth.userInfo.id]).join(",") : [].concat((0, _toConsumableArray3.default)((0, _uniq2.default)((0, _difference2.default)(employeeIds, cachedEmployeeIds)))).join(",");
      var queryObject = tenantId ? [{ key: "tenantId", value: tenantId }, { key: "ids", value: value }] : [{ key: "ids", value: value }];
      if (value.length) dispatch(commonActions.fetchEmployees(queryObject));
    }
    if (userIds.length > 0) {
      var cachedUserIds = [];
      if (common && common.citizenById) {
        cachedUserIds = Object.keys(common.citizenById);
      }
      var id = (0, _uniq2.default)((0, _difference2.default)(userIds, cachedUserIds)).indexOf(auth.userInfo.id) === -1 && auth.userInfo.type === "CITIZEN" ? [].concat((0, _toConsumableArray3.default)((0, _uniq2.default)((0, _difference2.default)(userIds, cachedUserIds))), [auth.userInfo.id]) : [].concat((0, _toConsumableArray3.default)((0, _uniq2.default)((0, _difference2.default)(userIds, cachedUserIds))));
      if (id.length) dispatch(commonActions.fetchCitizens({ tenantId: JSON.parse((0, _localStorageUtils.getUserInfo)()).tenantId, userName: JSON.parse((0, _localStorageUtils.getUserInfo)()).userName, id: id }));
    }
  }
};
// complaint autoRoutingEscalation success
var complaintAutoRouteFetchSucess = function complaintAutoRouteFetchSucess(payload) {
  return {
    type: actionTypes.COMPLAINTS_AUTOROUTING_FETCH_SUCCESS,
    payload: payload
  };
};

var fetchComplaintAutoRouting = exports.fetchComplaintAutoRouting = function fetchComplaintAutoRouting() {
  //Fetching Complaint auto from MDMS
  var requestBody = {
    MdmsCriteria: {
      tenantId: _common2.default.tenantId,
      moduleDetails: [{
        moduleName: "RAINMAKER-PGR",
        masterDetails: [{
          name: "AutoroutingEscalationMap"
        }]
      }]
    }
  };

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _api.httpRequest)(_endPoints.CATEGORY.GET.URL, _endPoints.CATEGORY.GET.ACTION, [], requestBody);

            case 3:
              payload = _context.sent;

              dispatch(complaintAutoRouteFetchSucess(payload));
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              dispatch(complaintCategoriesFetchError(_context.t0.message));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
//get user and employee id from action
var getUserEmployeeId = function getUserEmployeeId(user) {
  var splitArray = user.split(":");
  var id = splitArray[0];
  var role = splitArray[1];
  if (role && role.toLowerCase() === "citizen") {
    return { userId: id };
  } else {
    return { employeeId: id };
  }
};

// complaint categories success
var complaintCategoriesFetchSucess = function complaintCategoriesFetchSucess(payload) {
  return {
    type: actionTypes.COMPLAINTS_CATEGORIES_FETCH_SUCCESS,
    payload: payload
  };
};
var complaintDepartmentFetchSucess = function complaintDepartmentFetchSucess(payload) {
  return {
    type: actionTypes.COMPLAINTS_DEPARTMENT_FETCH_SUCCESS,
    payload: payload
  };
};
var complaintWardFetchSucess = function complaintWardFetchSucess(payload) {
  return {
    type: actionTypes.COMPLAINTS_WARD_FETCH_SUCCESS,
    payload: payload
  };
};

var complaintCategoriesFetchError = function complaintCategoriesFetchError(error) {
  return {
    type: actionTypes.COMPLAINTS_CATEGORIES_FETCH_ERROR,
    error: error
  };
};
var complaintWardFetchError = function complaintWardFetchError(error) {
  return {
    type: actionTypes.COMPLAINTS_WARD_FETCH_ERROR,
    error: error
  };
};

// complaints actions
var complaintFetchPending = function complaintFetchPending() {
  return {
    type: actionTypes.COMPLAINTS_FETCH_PENDING
  };
};

var complaintFetchComplete = function complaintFetchComplete(payload, overWrite) {
  return {
    type: actionTypes.COMPLAINTS_FETCH_COMPLETE,
    payload: payload,
    overWrite: overWrite
  };
};

var complaintSendSMS = function complaintSendSMS(message) {
  return {
    type: actionTypes.COMPLAINTS_SEND_MESSAGE,
    message: message
  };
};

var complaintSendSMSTo = function complaintSendSMSTo(message) {
  return {
    type: actionTypes.COMPLAINTS_SEND_MESSAGE_SHARECONTENT_TO,
    message: message
  };
};

var complaintSendSMSMedia = function complaintSendSMSMedia(message) {
  return {
    type: actionTypes.COMPLAINTS_SEND_MESSAGE_SHAREMEDIA,
    message: message
  };
};

var complaintFetchError = function complaintFetchError(error) {
  return {
    type: actionTypes.COMPLAINTS_FETCH_ERROR,
    error: error
  };
};

var complaintSortOrder = function complaintSortOrder(order) {
  return { type: actionTypes.COMPLAINTS_SORT_ORDER, order: order };
};

var getComplaintDisplayOrder = exports.getComplaintDisplayOrder = function getComplaintDisplayOrder(order) {
  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(complaintSortOrder(order));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var fetchComplaints = exports.fetchComplaints = function fetchComplaints(queryObject) {
  var hasUsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var overWrite = arguments[2];

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var tenantId, isTenantId, payload;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(complaintFetchPending());
              _context3.prev = 1;
              tenantId = "";

              if (queryObject && queryObject.length) {
                isTenantId = true;

                queryObject.forEach(function (obj) {
                  if (obj.key === "tenantId") {
                    isTenantId = false;
                  }
                });
                if (isTenantId) {
                  queryObject.push({ key: "tenantId", value: (0, _localStorageUtils.getTenantId)() });
                }
              }

              if (queryObject && queryObject.length == 0) {
                queryObject.push({ key: "tenantId", value: (0, _localStorageUtils.getTenantId)() });
              }

              _context3.next = 7;
              return (0, _api.httpRequest)(_endPoints.COMPLAINT.GET.URL, _endPoints.COMPLAINT.GET.ACTION, queryObject);

            case 7:
              payload = _context3.sent;

              if (payload.services && payload.services.length === 1) {
                tenantId = payload.services[0].tenantId;
              }
              checkUsers(dispatch, getState(), payload.actionHistory, hasUsers, tenantId);
              dispatch(complaintFetchComplete(payload, overWrite));
              _context3.next = 17;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](1);

              dispatch(complaintFetchError(_context3.t0.message));
              dispatch((0, _actions2.toggleSnackbarAndSetText)(true, {
                labelKey: _context3.t0.message,
                labelName: _context3.t0.message
              }, "error"));

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[1, 13]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var sendMessage = exports.sendMessage = function sendMessage(message) {
  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(complaintSendSMS(message));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var sendMessageTo = exports.sendMessageTo = function sendMessageTo(message) {
  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch(complaintSendSMSTo(message));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, undefined);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var sendMessageMedia = exports.sendMessageMedia = function sendMessageMedia(message) {
  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch(complaintSendSMSMedia(message));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, undefined);
    }));

    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var fetchComplaintCategories = exports.fetchComplaintCategories = function fetchComplaintCategories() {
  //Fetching Complaint Categories from MDMS
  var requestBody = {
    MdmsCriteria: {
      tenantId: _common2.default.tenantId,

      moduleDetails: [{
        moduleName: "RAINMAKER-PGR",
        masterDetails: [{
          name: "ServiceDefs"
          // filter: "$.*.hierarchyType"
        }]
      }]
    }
  };

  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return (0, _api.httpRequest)(_endPoints.CATEGORY.GET.URL, _endPoints.CATEGORY.GET.ACTION, [], requestBody);

            case 3:
              payload = _context7.sent;


              dispatch(complaintCategoriesFetchSucess(payload));
              _context7.next = 10;
              break;

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](0);

              dispatch(complaintCategoriesFetchError(_context7.t0.message));

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, undefined, [[0, 7]]);
    }));

    return function (_x13) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var fetchCompalainDepartment = exports.fetchCompalainDepartment = function fetchCompalainDepartment() {
  //Fetching Complaint Wards from MDMS

  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch) {
      var generatedhash, requestBody, response, payload;
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              generatedhash = localStorage.getItem("generatedhash");
              requestBody = {
                reqData: {
                  platform: "digit",
                  id: "ekmchr",
                  hashTk: generatedhash,
                  deptStatus: ""
                }
              };
              _context8.next = 5;
              return (0, _api.httpRequest)("tender-be-service/getDepartment", _endPoints.CATEGORY.GET.ACTION, [], requestBody, [], {}, true);

            case 5:
              response = _context8.sent;
              payload = {
                MdmsRes: {
                  "common-masters": {
                    Department: response.data
                  }
                }
              };


              dispatch(complaintDepartmentFetchSucess(payload));
              _context8.next = 13;
              break;

            case 10:
              _context8.prev = 10;
              _context8.t0 = _context8["catch"](0);

              console.log(_context8.t0.message);

            case 13:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, undefined, [[0, 10]]);
    }));

    return function (_x14) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var complaintFetchCloseComplete = function complaintFetchCloseComplete(payload, overWrite) {
  return {
    type: actionTypes.COMPLAINTS_FETCH_CLOSE_COMPLETE,
    payload: payload,
    overWrite: overWrite
  };
};
var checkUsersNew = function checkUsersNew(dispatch, state, actionHistory, hasUsers, tenantId) {
  if (hasUsers) {
    var employeeIds = [],
        userIds = [];
    actionHistory.forEach(function (actions) {
      actions && actions.actionInfo && actions.actionInfo.forEach(function (action) {
        if (action.by) {
          var _getUserEmployeeId3 = getUserEmployeeId(action.by),
              userId = _getUserEmployeeId3.userId,
              employeeId = _getUserEmployeeId3.employeeId;

          if (userId) userIds.push(userId);
          if (employeeId) employeeIds.push(employeeId);
        }
        if (action.assignee) {
          var _getUserEmployeeId4 = getUserEmployeeId(action.assignee),
              _userId2 = _getUserEmployeeId4.userId,
              _employeeId2 = _getUserEmployeeId4.employeeId;

          if (_userId2) userIds.push(_userId2);
          if (_employeeId2) employeeIds.push(_employeeId2);
        }
      });
    });
    var common = state.common,
        auth = state.auth;

    if (employeeIds.length > 0) {
      var cachedEmployeeIds = [];
      if (common && common.employeeById) {
        cachedEmployeeIds = Object.keys(common.employeeById);
      }
      var value = (0, _uniq2.default)((0, _difference2.default)(employeeIds, cachedEmployeeIds)).indexOf(auth.userInfo.id) === -1 && auth.userInfo.type !== "CITIZEN" ? [].concat((0, _toConsumableArray3.default)((0, _uniq2.default)((0, _difference2.default)(employeeIds, cachedEmployeeIds))), [auth.userInfo.id]).join(",") : [].concat((0, _toConsumableArray3.default)((0, _uniq2.default)((0, _difference2.default)(employeeIds, cachedEmployeeIds)))).join(",");
      var queryObject = tenantId ? [{ key: "tenantId", value: tenantId }, { key: "ids", value: value }] : [{ key: "ids", value: value }];
      if (value.length) dispatch(commonActions.fetchEmployees(queryObject));
    }
    if (userIds.length > 0) {
      var cachedUserIds = [];
      if (common && common.citizenById) {
        cachedUserIds = Object.keys(common.citizenById);
      }
      var id = (0, _uniq2.default)((0, _difference2.default)(userIds, cachedUserIds)).indexOf(auth.userInfo.id) === -1 && auth.userInfo.type === "CITIZEN" ? [].concat((0, _toConsumableArray3.default)((0, _uniq2.default)((0, _difference2.default)(userIds, cachedUserIds))), [auth.userInfo.id]) : [].concat((0, _toConsumableArray3.default)((0, _uniq2.default)((0, _difference2.default)(userIds, cachedUserIds))));
      if (id.length) dispatch(commonActions.fetchCitizens({ id: id }));
    }
  }
};
var complaintFetchCompleteUpdate = function complaintFetchCompleteUpdate(payload, overWrite) {
  return {
    type: actionTypes.COMPLAINTS_FETCH_COMPLETE_UPDATE,
    payload: payload,
    overWrite: overWrite
  };
};
//fetchComplaintsNew
var fetchComplaintsNew = exports.fetchComplaintsNew = function fetchComplaintsNew(queryObject) {
  var hasUsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var overWrite = arguments[2];

  return function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch, getState) {
      var tenantId, payload;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              dispatch(complaintFetchPending());
              _context9.prev = 1;
              tenantId = "";
              _context9.next = 5;
              return (0, _api.httpRequest)(_endPoints.COMPLAINTUPDATE.GET.URL, _endPoints.COMPLAINTUPDATE.GET.ACTION, queryObject);

            case 5:
              payload = _context9.sent;


              if (payload && payload["serviceRequestComplaints"].length > 0) {
                tenantId = payload["serviceRequestComplaints"][0].actionInfo[0].tenantId;
                checkUsersNew(dispatch, getState(), payload["serviceRequestComplaints"], hasUsers, tenantId);
                // if(queryObject[0].value.indexOf("assigned")!==-1)
                // {
                //   //window.localStorage.setItem("assignedTotalComplaints",payload.length);
                // }
                // else  if(queryObject[0].value.indexOf("open")!==-1)
                // {
                //   //window.localStorage.setItem("unassignedTotalComplaints",payload.length);
                // }

                dispatch(complaintFetchCompleteUpdate(payload["serviceRequestComplaints"], overWrite));
              }
              if (payload && payload["serviceRequestComplaints"].length == 0) {
                payload = [];
                dispatch(complaintFetchCompleteUpdate(payload, overWrite));
              }
              _context9.next = 13;
              break;

            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9["catch"](1);

              dispatch(complaintFetchError(_context9.t0.message));

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, undefined, [[1, 10]]);
    }));

    return function (_x16, _x17) {
      return _ref9.apply(this, arguments);
    };
  }();
};

//fetchComplaintsClosed
var fetchCloseComplaints = exports.fetchCloseComplaints = function fetchCloseComplaints(queryObject) {
  var hasUsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var overWrite = arguments[2];

  return function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch, getState) {
      var tenantId, payload;
      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              dispatch(complaintFetchPending());
              _context10.prev = 1;
              tenantId = "";
              _context10.next = 5;
              return (0, _api.httpRequest)(_endPoints.CLOSECOMPLAINT.GET.URL, _endPoints.COMPLAINT.GET.ACTION, queryObject);

            case 5:
              payload = _context10.sent;

              if (payload.services && payload.services.length >= 1) {
                tenantId = payload.services[0].tenantId;
                (0, _localStorageUtils2.setCloseComplaintsCount)(payload.services.length);
                checkUsers(dispatch, getState(), payload.actionHistory, hasUsers, tenantId);
                dispatch(complaintFetchCloseComplete(payload, overWrite));
              }
              if (payload.services && payload.services.length === 0) {
                payload = [];
                dispatch(complaintFetchCloseComplete(payload, overWrite));
              }
              _context10.next = 13;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](1);

              dispatch(complaintFetchError(_context10.t0.message));

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, undefined, [[1, 10]]);
    }));

    return function (_x19, _x20) {
      return _ref10.apply(this, arguments);
    };
  }();
};

var fetchComplaintWards = exports.fetchComplaintWards = function fetchComplaintWards() {
  //Fetching Complaint Wards from MDMS

  return function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch) {
      var requestBody, payload;
      return _regenerator2.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              requestBody = {
                reqData: {
                  platform: "digit",
                  id: "ekmchr"
                }
              };
              _context11.next = 4;
              return (0, _api.httpRequest)("licmgm/getWardList", _endPoints.CATEGORY.GET.ACTION, [], requestBody, [], {}, true);

            case 4:
              payload = _context11.sent;


              dispatch(complaintWardFetchSucess(payload.data));
              _context11.next = 11;
              break;

            case 8:
              _context11.prev = 8;
              _context11.t0 = _context11["catch"](0);

              dispatch(complaintWardFetchError(_context11.t0.message));

            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, undefined, [[0, 8]]);
    }));

    return function (_x21) {
      return _ref11.apply(this, arguments);
    };
  }();
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/complaints/actions.js
// module id = 194
// module chunks = 1137